import { Fragment } from "react";

import useClubStaffGrid from "./UseClubStaffGrid";

import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";
import ActionIntraPageButton from "@usas/ui-web/components/buttons/ActionIntraPageButton";
import OrgRoleStaffRoleTreeView from "@usas/ui-web/components/tree/orgRoleTree/OrgRoleStaffRoleTreeView";
import { Icon, Table, Td, Th, Tr } from "@usas/ui-web/components/table/Table";

import { SORT_TYPES } from "@usas/ui-web/components/table/utils/TableConstants";
import { formatMultipleValuesForDisplay } from "@usas/ui-web/components/table/utils/TableUtils";

const NestedTable = ({ data, personId, onDeleteClicked }) => (
  <Table.Nested>
    <thead>
      <tr>
        <th>Roles</th>
        <th></th>
      </tr>
    </thead>
    <Table.NestedBody data={data} colSpan={2} noDataText='No Roles'
      renderRow={(role, i) =>
        <tr key={i}>
          <td>{role.orgRoleName}</td>
          <Td.Action>
            {onDeleteClicked &&
              <Icon.Delete onClick={(e) => onDeleteClicked(e, personId, role.personOrgRoleDurationId)} />
            }
          </Td.Action>
        </tr>
      } />
  </Table.Nested>
);

const ClubStaffGrid = ({ data, isLoading, onAddClicked, onEditClicked, onDeleteClicked }) => {
  const {
    roleGroupId,
    gridState,
    onOrgRoleFilterChanged,
  } = useClubStaffGrid(data);

  return (
    <Fragment>
      <div className="row usas-extra-bottom-margin">
        <div className="col-xs-12 col-sm-6 col-md-4">
          {roleGroupId &&
            <OrgRoleStaffRoleTreeView
              label="Filter By Role"
              name="orgRole"
              value={gridState.orgRole}
              roleGroupId={roleGroupId}
              singleSelect={false}
              selectableLeavesOnly={false}
              onChange={(value) => { onOrgRoleFilterChanged(value) }} />
          }
        </div>
      </div>
      {gridState.orgRole.length > 0 &&
        <div className="row usas-extra-top-margin">
          <div className="col-xs-12 col-md-4">
            <SecondaryButton type="button" onClick={() => onOrgRoleFilterChanged([])}>Clear Filters</SecondaryButton>
          </div>
        </div>
      }
      <Table.ContextWrapper data={gridState.gridData} rowIdKey={'personId'} >
        <Table.Large>
          <thead>
            <Tr.Top colSpan={4} showDataTotal={isLoading !== true} dataName='Staff' dataTotal={data.length}>
              <ActionIntraPageButton onClick={onAddClicked}>Add Staff</ActionIntraPageButton>
            </Tr.Top>
            <tr>
              <Th.Sort sortKey={'lastName'} sortType={SORT_TYPES.ALPHABETICAL}>Name</Th.Sort>
              <Th.Sort sortKey={'email'} sortType={SORT_TYPES.ALPHABETICAL}>Email</Th.Sort>
              <th>Roles</th>
              <Th.Action>
                <Icon.ExpandAll />
              </Th.Action>
            </tr>
          </thead>
          <Table.Body colSpan={4} isLoading={isLoading} noDataText='No Club Staff'
            renderRow={(clubStaff, i) =>
              <Tr.Accordion key={i} rowId={clubStaff.personId} tableColOffsetStart={2} tableColSpan={2} nestedTable={<NestedTable data={clubStaff.personOrgRole} personId={clubStaff.personId} onDeleteClicked={onDeleteClicked} />}>
                <td>{clubStaff.preferredName || clubStaff.firstName} {clubStaff.lastName}</td>
                <td>{clubStaff.email}</td>
                <Td.Multiline maxWidth="20vw">{formatMultipleValuesForDisplay(clubStaff.personOrgRole, 'orgRoleName')}</Td.Multiline>
                <Td.Action>
                  <Icon.Edit onClick={(e) => onEditClicked(e, clubStaff)} />
                  <Icon.Expand rowId={clubStaff.personId} />
                </Td.Action>
              </Tr.Accordion>
            } />
        </Table.Large>
        <Table.Small>
          <thead>
            <Tr.Top colSpan={3} showDataTotal={isLoading !== true} dataName='Staff' dataTotal={data.length}>
              <ActionIntraPageButton onClick={onAddClicked}>Add Staff</ActionIntraPageButton>
            </Tr.Top>
            <tr>
              <Th.Sort sortKey={'lastName'} sortType={SORT_TYPES.ALPHABETICAL}>Name</Th.Sort>
              <Th.Sort sortKey={'email'} sortType={SORT_TYPES.ALPHABETICAL}>Email</Th.Sort>
              <Th.Action>
                <Icon.ExpandAll />
              </Th.Action>
            </tr>
          </thead>
          <Table.Body colSpan={3} isLoading={isLoading} noDataText='No Club Staff'
            renderRow={(clubStaff, i) =>
              <Tr.Accordion key={i} rowId={clubStaff.personId} tableColSpan={3} nestedTable={<NestedTable data={clubStaff.personOrgRole} personId={clubStaff.personId} onDeleteClicked={onDeleteClicked} />}>
                <td>{clubStaff.preferredName || clubStaff.firstName} {clubStaff.lastName}</td>
                <td>{clubStaff.email}</td>
                <Td.Action>
                  <Icon.Edit onClick={(e) => onEditClicked(e, clubStaff)} />
                  <Icon.Expand rowId={clubStaff.personId} />
                </Td.Action>
              </Tr.Accordion>
            } />
        </Table.Small>
      </Table.ContextWrapper>
    </Fragment>
  );
};

export default ClubStaffGrid;